import { darken } from 'polished';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

const getTemplateColumns = ({ maxSlotsPerRow }) => {
  if (!maxSlotsPerRow) {
    return css`
      grid-template-columns: repeat(auto-fill, 90px);
    `;
  }

  return css`
    grid-template-columns: repeat(${maxSlotsPerRow}, 1fr);
  `;
};

// The SlotPicker has a horizontal scroll on mobile and a grid on desktop.
export const SlotPickerTimesList = styled.div`
  display: grid;
  ${getTemplateColumns}
  gap: 8px;

  ${applyStylesForScreenSize([SCREEN_SIZES.PHONE], css`
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  `)}
`;

export const SlotPickerTime = styled.button.attrs({
  type: 'button',
})`
  padding: 5px 16px;

  border-radius: 8px;
  border: 0;

  background-color: ${BRAND_COLORS.lightGreen};
  color: ${BRAND_COLORS.white};

  ${TYPOGRAPHY.OPEN_SANS.base};
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  white-space: nowrap;

  cursor: pointer;

  transition-property: background-color,
    border-color,
    color,
    font-variation-settings;
  transition-duration: 200ms;
  transition-timing-function: ease;

  &:hover {
    background-color: ${darken(0.1, BRAND_COLORS.lightGreen)};
    font-variation-settings: 'wght' 700;
  }
`;

export const SlotPickerScrollButton = styled.button.attrs({
  type: 'button',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0;

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  background-color: transparent;
  border-width: 0;

  ${TYPOGRAPHY.OPEN_SANS.base};
  font-size: 13px;
  color: ${(props) =>
    (props.disabled ? BRAND_COLORS.lightGray : BRAND_COLORS.black)};

  transition: background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    color: ${(props) =>
      (props.disabled ? BRAND_COLORS.lightGray : BRAND_COLORS.lightGreen)};
  }
`;
